import { ref, reactive } from 'vue'
import { Auth } from '@/services/authService'
import { MaybeAccount } from '@/services/authService'
import { NavigationClient } from '@azure/msal-browser'

export const initialized = ref(false)
export const account = ref(null)
export const error = ref()
const createEmptyProfile = () => ({ 
    name: null, 
    username: null,
    localAccountId: null,
    dB_isAdmin: null, 
    dB_defaultClientId: null, 
    dB_firstProjectId:null,
    dB_loggedInBack:null
    })

export const userProfile = ref(createEmptyProfile()) // Guard ensures we only sync from MSAL on initialization/login, not on logout or manual profile resets

function syncUserProfile(data, guard = false) {
  if (!data) {
    userProfile.value = createEmptyProfile()
    return
  }
  const updatedProfile = { ...userProfile.value }
  if (guard) {
    Object.keys(data).forEach(key => {
        // Only overwrite if MSAL actually provided a value (is not null/undefined)
        if (key in updatedProfile) {
          if (data[key] !== undefined && data[key] !== null) {
            updatedProfile[key] = data[key]
          }
        }
        
    })

  } else {
      Object.keys(data).forEach(key => {
        if (key in updatedProfile) {
            updatedProfile[key] = data[key]
        }
      })
  }
  //console.log('🔄 [Profile Sync]: Updating user profile with MSAL data:', updatedProfile)
  userProfile.value = updatedProfile
}

async function initialize (client) {
  if (initialized.value === true) {
    return account.value
  }
  return Auth.initialize(client)
    .then(data => {
      account.value = data
      initialized.value = true
      syncUserProfile(data)
      return data
    })
}

async function login () {
  error.value = ''
  return Auth.login()
    .then(data => {
      account.value = data
      error.value = ''
      initialized.value = true
      syncUserProfile(data)
    })
    .catch(err => {
      error.value = err.message
      throw(err)
    })
}

async function logout () {
  return Auth.logout().then(() => {
    account.value = null
    syncUserProfile(null)
    initialized.value = false // Reset on logout
  })
}

// export const auth = reactive({
//   error,
//   account,
//   initialized,
//   initialize,
//   login,
//   logout,
// })
export const auth = {
  error,
  account,
  userProfile,
  initialized,
  initialize,
  login,
  logout,
  syncUserProfile
}
